import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SubscriptionLike } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Spinner } from 'src/app/core/services/spinner.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { ISUPPLIER } from 'src/app/shared/model/iSupplier.model';
import { TicketRequest } from 'src/app/shared/model/ticket-access-request.model';
import { ProfileService } from 'src/app/shared/service/profile.service';
import { IsupplierService } from 'src/app/shared/service/races-isupplier-access.service';
import { DialogiSupplySearchSSOComponent } from './search-sso/search-sso.component';

@Component({
  selector: 'app-i-supplier-form',
  templateUrl: './i-supplier-form.component.html',
  styleUrls: ['./i-supplier-form.component.scss']
})
export class ISupplierFormComponent implements OnInit, OnDestroy {
  roleList = ['PO Management', 'Serialization Mgt', 'Invoice Mgt'];
  iSupplier: ISUPPLIER = new ISUPPLIER();
  iSupplierForm: FormGroup;
  request: TicketRequest[] = [];
  isSpin: boolean;
  checkSubmit: boolean;
  subscription: SubscriptionLike;
  width: number = window.innerWidth;

  ssoDialogRef: MatDialogRef<DialogiSupplySearchSSOComponent>;

  constructor(
    private spinner: Spinner,
    private location: Location,
    private fb: FormBuilder,
    private toastService: ToastrService,
    private router: Router,
    private dialog: MatDialog,
    private service: IsupplierService,
    private serviceProfile: ProfileService
  ) { }

  ngOnInit(): void {
    this.initFormiSupplier();
    this.getListTicket();
 }

  ngOnDestroy() {
    // unsubscribe
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getListTicket(event?) {
    if (event) {
      event.srcElement.classList.remove('rotate');
      setTimeout(() => {
        event.srcElement.classList.add('rotate');
      }, 0);
    }
    this.subscription = this.service.getRequestIsupplierAccessList().subscribe((res) => {
      this.request = res.data;
    }, (err) => {});
  }

  initFormiSupplier(): void {
    this.iSupplierForm = this.fb.group({
      userName: [{value: this.iSupplier.userName, disabled: true}],
      email: [{value: this.iSupplier.email, disabled: true }],
      firstName: [this.iSupplier.firstName, [Validators.required]],
      lastName: [this.iSupplier.lastName, [Validators.required]],
      purchaseOrder: [this.iSupplier.purchaseOrder, [Validators.required]],
      companyName: [this.iSupplier.companyName, [Validators.required]],
      companyPOs: [this.iSupplier.companyPOs || ''],
      companyParent: [this.iSupplier.companyParent, [Validators.required]],
      buyerContact: [this.iSupplier.buyerContact, [Validators.required]],
      role: [this.iSupplier.role, [Validators.required]],
    });

    this.serviceProfile.getProfileUser().subscribe((res: any) => {
      this.iSupplier.userName = res.data.sso;
      this.iSupplier.email = res.data.email;

      this.iSupplierForm = this.fb.group({
        userName: [{value: this.iSupplier.userName, disabled: true}],
        email: [{value: this.iSupplier.email, disabled: true }],
        firstName: [this.iSupplier.firstName, [Validators.required]],
        lastName: [this.iSupplier.lastName, [Validators.required]],
        purchaseOrder: [this.iSupplier.purchaseOrder, [Validators.required]],
        companyName: [this.iSupplier.companyName, [Validators.required]],
        companyPOs: [this.iSupplier.companyPOs || ''],
        companyParent: [this.iSupplier.companyParent, [Validators.required]],
        buyerContact: [this.iSupplier.buyerContact, [Validators.required]],
        role: [this.iSupplier.role, [Validators.required]],
      });
    });
  }

  /**
   * Marks all controls in a form group as touched
   * @param formGroup - The form group to touch
   */
  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  submitiSupplierFormForm(): void {
    if (this.checkSubmit) {
      this.setErrorForm(this.iSupplierForm);
    }
    if (!this.iSupplierForm.valid) {
      this.markFormGroupTouched(this.iSupplierForm);
      return;
    } else {
      this.openDialog();
    }
  }

  goToApplication() {
    window.open('https://races.gerenewableenergy.com/');
  }

  getInitFormByID(id) {
    this.spinner.show();
    this.service.getRequestIsupplierAccess(id).subscribe((res) => {
      this.spinner.hide();
      this.iSupplier = new ISUPPLIER(res.data);
      this.initFormiSupplier();
    });
  }

  openDialog() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_REQUEST_ACCESS,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        const body = new ISUPPLIER(this.iSupplierForm.getRawValue(), false).convertToReqBody();
        this.spinner.show();
        this.service.requestIsupplierAccess(body).subscribe((res) => {
          this.spinner.hide();
          this.toastService.success(MESSAGE_TOAST.REQUEST_ACCESS_TICKET_SUCCESS);
          // this.getListTicket();
          setTimeout(() => {
            location.reload();
          }, 1000);
          // this.resetForm(this.iSupplierForm);
        });
      }
    });
  }

  resetForm(formGroup: FormGroup) {
    let control: AbstractControl = null;
    formGroup.reset();
    formGroup.markAsUntouched();
    Object.keys(formGroup.controls).forEach((name) => {
      control = formGroup.controls[name];
      control.setErrors(null);
    });
    formGroup.setErrors({ invalid: true });
    this.checkSubmit = true;
  }

  setErrorForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((name) => {
      if (!formGroup.controls[name].value) {
        formGroup.controls[name].setErrors({ nodata: true });
      }
    });
    return formGroup;
  }

  searchSSO(event) {
    this.ssoDialogRef = this.dialog.open(DialogiSupplySearchSSOComponent, {
      width: this.width > 1000 ? '40%' : '100%',
      maxWidth: '100%',
      maxHeight: '500px',
      data: {}
    });
    this.ssoDialogRef.afterClosed().pipe(
      filter(name => name)
    ).subscribe(name => {
      this.iSupplierForm.controls.buyerContact.setValue(name);
    });
  }

}
